import React, { useState } from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";
import format from "date-fns/format";

import { formatDate } from "../../helpers/date";
import { downloadCSV } from "../reports/utils";

import HeaderWrapper from "../common/HeaderWrapper";

const MonthlySegmentDisplay = ({ data, project }) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const today = new Date();

  const monthlySegmentData = data?.filter(
    (item) => new Date(item.startDate) <= today
  );

  const handlePageSizeChange = (size) => {
    setPageSize(size);
  };

  const handlePageChange = (p) => {
    setPage(p);
  };

  const columns = [
    {
      Header: "Start Date",
      accessor: "startDate",
      id: "startDate",
      Cell: (row) => formatDate(row.value, "MM/dd/yyyy")
    },
    {
      Header: "End Date",
      accessor: "endDate",
      id: "endDate",
      Cell: (row) => (row.value ? formatDate(row.value, "MM/dd/yyyy") : "--")
    },
    {
      Header: "Budget Hours",
      accessor: "budgetHours",
      id: "budgetHours",
      Footer: () => {
        const total = data.reduce((sum, row) => sum + row.budgetHours, 0);
        return total;
      }
    },
    {
      Header: "Actual Consumed",
      accessor: "consumed",
      id: "consumed",
      Footer: () => {
        const total = data.reduce((sum, row) => sum + row.consumed, 0);
        return total.toFixed(2);
      }
    },
    {
      Header: "Billable Consumed",
      accessor: "consumedBillable",
      id: "consumedBillable",
      Footer: () => {
        const total = data.reduce((sum, row) => sum + row.consumedBillable, 0);
        return total.toFixed(2);
      }
    }
  ];

  const handleExportToCsv = () => {
    const totals = {
      budgetHours: data
        .reduce((sum, row) => sum + row.budgetHours, 0)
        .toFixed(2),
      consumed: data.reduce((sum, row) => sum + row.consumed, 0).toFixed(2),
      consumedBillable: data
        .reduce((sum, row) => sum + row.consumedBillable, 0)
        .toFixed(2)
    };
    downloadCSV(
      `MonthlySegments-${format(new Date(), "yyyy_MM_dd")}`,
      [...data, totals],
      columns,
      `${project.name} ${format(new Date(), "MM/dd/yyyy")}`
    );
  };

  if (!monthlySegmentData || !monthlySegmentData.length) {
    return null;
  }

  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[{ label: "Monthly Segments" }]}
        onClickAction={[
          {
            action: handleExportToCsv,
            className: "btn btn-success",
            text: "Export To CSV"
          }
        ]}
      />
      <div className="content-wrapper">
        <ReactTable
          className="-highlight"
          columns={columns}
          page={page}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          data={monthlySegmentData}
          defaultSorted={[
            {
              id: "startDate",
              desc: true
            }
          ]}
          pageSize={pageSize}
          getTrProps={(state, rowInfo) => {
            if (rowInfo) {
              const { startDate, endDate } = rowInfo.original;
              const start = new Date(startDate);
              const end = new Date(endDate);

              if (new Date() >= start && new Date() <= end) {
                return {
                  style: {
                    backgroundColor: "rgba(80, 172, 203, 0.2)"
                  }
                };
              }
            }
            return {};
          }}
        />
      </div>
    </React.Fragment>
  );
};

MonthlySegmentDisplay.propTypes = {
  data: PropTypes.array,
  project: PropTypes.object
};

export default MonthlySegmentDisplay;
